import React from "react";
import styled from "styled-components";
import { MidLBox } from "../style/BoxModel";
import db from "../firebase";

export default function Whatelse() {
  const [whatElseData, setWhatElseData] = React.useState();

  React.useEffect(() => {
    db.collection("what-else").onSnapshot((snapshot) => {
      let items = [];
      snapshot.docs.forEach((doc) => {
        items.push({
          id: doc.id,
          ...doc.data(),
        });
      });
      setWhatElseData(items.sort((a, b) => a.serial - b.serial));
    });
  }, []);

  return (
    <main className="body">
      <Container>
        <div className="page-cover">
          <div className="title">What else?</div>
        </div>
        <MidLBox>
          <div className="centered">
            Besides what I do professionally, I love learning Technology,
            Science, Logic, History, IR, Social problems, and a lot by and for
            the sake of debate and obviously for my own curiosity.
            <br />
            Love to Travel.
            <br />
            Do Debate and train debating.
          </div>
          <div className="cont">
            {whatElseData ? (
              React.Children.toArray(
                whatElseData.map((data) => (
                  <div className="redirect-box">
                    <div className="redirect-box-content redirect-box-content_img">
                      <img
                        src={data.image}
                        alt={`${data.title} cover`}
                        loading="lazy"
                      />
                    </div>
                    <div className="redirect-box-content text">
                      {data.title ? <h1>{data.title}</h1> : null}
                      <br />
                      {data.description ? <p>{data.description}</p> : null}
                      <br />
                      {data.linkHref && data.linkText ? (
                        <a
                          href={data.linkHref}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {data.linkText && data.linkText}
                        </a>
                      ) : null}
                    </div>
                    {/* https://aklajim.myportfolio.com */}
                  </div>
                ))
              )
            ) : (
              <p>No data available. Please wait or reload your window.</p>
            )}
          </div>
        </MidLBox>
      </Container>
    </main>
  );
}

const Container = styled.div`
  font-family: "Kaisei HarunoUmi", serif;
  .page-cover {
    width: 100%;
    aspect-ratio: 18/3;
    background-color: var(--aliceblue);
    background-image: url("/image/photo/whatelsecover.webp");
    background-position: center;
    background-position-y: -120px;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-size: cover;
    transform: scaleX(-1);
    background-size: 100%;
    position: relative;
    @media (max-width: 768px) {
      aspect-ratio: 18/4;
    }
    @media (max-width: 548px) {
      background-position-y: center;
      background-position-x: center;
      background-size: cover;
      aspect-ratio: 16/8;
    }
    .title {
      font-family: "Kaisei HarunoUmi", serif;
      background-color: var(--white);
      color: var(--dark);
      position: absolute;
      top: 20%;
      right: 15%;
      font-size: 40px;
      font-weight: 900;
      padding: 20px;
      transform: scaleX(-1);
    }
  }
  .centered {
    padding: 20px;
    margin: 20px auto;
    text-align: center;
    max-width: 600px;
  }
  .cont {
    @media (max-width: 548px) {
      padding: 0 20px;
    }
  }
  .redirect-box {
    display: flex;
    flex-flow: row;
    &:nth-child(even) {
      flex-flow: row-reverse;
    }
    @media (max-width: 548px) {
      flex-flow: column !important;
    }
    &-content {
      background-color: transparent;
      width: 50%;
      overflow: hidden;
      /* @media (min-width: 449px) {
        aspect-ratio: 4/3;
      }
      @media (min-width: 769px) {
        aspect-ratio: 4/2;
      } */
      @media (max-width: 448px) {
        /* aspect-ratio: 1/1; */
        width: 100%;
      }
      &.redirect-box-content_img {
        background-color: var(--aliceblue);
        display: flex;
        object-fit: cover;
      }
      img {
        width: 100%;
        margin: auto;
      }
      &.text {
        padding: 50px;
        color: var(--dark);
        a {
          color: var(--dark);
          position: relative;
          text-decoration: none;
          z-index: 1;
          &::before {
            z-index: -1;
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            width: 100%;
            height: 4px;
            background: var(--green-transparent);
            transition: all 0.3s ease-in-out;
          }
          &:hover {
            &::before {
              height: 100%;
            }
          }
        }
      }
    }
  }
`;
